var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmManageTeam = function SvgBmManageTeam(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20.765",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -0.006)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.731,
    cy: 1.731,
    r: 1.731,
    transform: "translate(2 17.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.731,
    cy: 1.731,
    r: 1.731,
    transform: "translate(9.269 17.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.731,
    cy: 1.731,
    r: 1.731,
    transform: "translate(16.538 17.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.192,19.808a.692.692,0,0,0,.692-.692V17.385h5.885v1.731a.692.692,0,1,0,1.385,0V17.385h5.885v1.731a.692.692,0,0,0,1.385,0V16.692A.692.692,0,0,0,18.731,16H4.192a.692.692,0,0,0-.692.692v2.423A.692.692,0,0,0,4.192,19.808Z",
    transform: "translate(-0.462 -4.921)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.077,7.749a4.15,4.15,0,0,0,5.67-1.516,4.029,4.029,0,0,0,.561-2.077,4.029,4.029,0,0,0-.561-2.077,4.15,4.15,0,0,0-7.186,0A4.029,4.029,0,0,0,9,4.156a4.029,4.029,0,0,0,.561,2.077,4.188,4.188,0,0,0,1.516,1.516Zm-.519-3.51.367-.388a.27.27,0,0,1,.388,0l1.149,1.177,2.513-2.513a.263.263,0,0,1,.194-.083.27.27,0,0,1,.194.083l.367.388a.215.215,0,0,1,.083.18.235.235,0,0,1-.083.187L12.669,6.35a.235.235,0,0,1-.187.083.215.215,0,0,1-.18-.083L10.558,4.606a.215.215,0,0,1-.083-.18A.228.228,0,0,1,10.558,4.239Z",
    transform: "translate(-2.154)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmManageTeam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_ManageTeam.96937648.svg";
export { ForwardRef as ReactComponent };